"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateCalcContainerSchema = exports.ValidFieldTypes = void 0;
// IntermediateCalcs namespace converted to module
const _imports_1 = require("../_imports");
const _shared_1 = require("../_shared");
// please ensure that this is subset of DataTapeField.Type
exports.ValidFieldTypes = [
    'integer',
    'optionalInteger',
    'string',
    'optionalString',
    'boolean',
    'optionalBoolean',
    'float',
    'optionalFloat',
    'date',
    'optionalDate',
    'percentage',
    'optionalPercentage',
];
// Zod schema for IntermediateCalcContainer
const CalcFormulaConfigSchema = _shared_1.FormulaConfigSchema.extend({
    type: _imports_1.z.literal('formula'),
});
exports.IntermediateCalcContainerSchema = _imports_1.z.object({
    field: _imports_1.z.string(),
    config: CalcFormulaConfigSchema,
    fieldType: _imports_1.z.enum(exports.ValidFieldTypes),
});
//# sourceMappingURL=IntermediateCalcs.js.map